import services from '../../../services'

const state = {
}

const actions = {
  async stationScreenList ({commit}, query) {
    return await services.stationScreen_getList(query)
  },

  async getStationScreen ({commit}, query) {
    return await services.stationScreen_getOne(query)
  },

  async addStationScreen ({commit}, options) {
    return await services.stationScreen_addOne(options)
  },

  async addNewStationScreen({commit}, options) {
    return await services.stationScreen_addNewOne(options)
  },

  async updateStationScreen ({commit}, options) {
    return await services.stationScreen_updateOne(options)
  },

  async deleteStationScreen ({commit}, options) {
    return await services.stationScreen_deleteList(options)
  }
}

const mutations = {
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/stationScreen.js